require([
  'jquery',
  'mojo-analytics',
  'utils',
  'signup',
  'slick',
  'pushy',
], function (
  $,
  MojoAnalytics,
  utils
) {


  var OVERLAY_CLASS_ON_BODY = 'has--fixed-overlay',

    r = {
      $formOverlays: $('.form-overlay'),
      $signupTrigger: $('.js-signup-trigger'),
      $signupSection: $('#overlaySignup'),
      $loginSection: $('#overlayLogin'),
      $overlayClose: $('.form-overlay-close'),
      $loginTrigger: $('.js-login-trigger'),
      $htmlBody: $('html, body'),
      $heroCarousel: $('#heroCarousel'),
      $googleLogin: $('.login-google'),
      $facebookLogin: $('.login-facebook'),
    },

    landingParam = utils.getURLParameter('landing');

  var isOverlayVisible = false ;

  function handleOverlay (overlayElem) {
    r.$formOverlays.hide();

    overlayElem.fadeIn(200);

    isOverlayVisible = true;

    r.$heroCarousel.slick('slickPause');

    r.$htmlBody.addClass(OVERLAY_CLASS_ON_BODY);
  }

  function handleSignupSection (e) {
    e.preventDefault();
    MojoAnalytics.sendEvent({
      eventName: 'Viewed Sign Up Form',
      eventData: {
        page_type: 'Education',
        homepage_location: $(e.target).data('button-location'),
        ref: utils.getURLParameter('ref'),
      },
    });
    handleOverlay(r.$signupSection);
  }

  function handleLoginSection (e) {
    e.preventDefault();
    handleOverlay(r.$loginSection);
  }

  function handleOverlayCloseViaEsc (e) {
    if (!isOverlayVisible) {
      return;
    }

    if (e.keyCode === 27) {
      handleOverlayClose();
    }
  }

  function handleOverlayClose (e) {
    if (e) {
      e.preventDefault();
    }

    r.$formOverlays.hide();

    isOverlayVisible = false;

    r.$heroCarousel.slick('slickPlay');

    r.$htmlBody.removeClass(OVERLAY_CLASS_ON_BODY);
  }


  function handleHeroCarousel () {
    var previousSlide;
    r.$heroCarousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      previousSlide = currentSlide;
      // $('.hero > .screen-' + currentSlide).removeClass('current');
      $('.hero > .screen-' + nextSlide).addClass('animatable');
    });

    r.$heroCarousel.on('afterChange', function (event, slick, currentSlide) {
      $('.hero > .screen-' + previousSlide).removeClass('current');
      $('.hero > .screen-' + currentSlide)
        .toggleClass('animatable current');
    });

    r.$heroCarousel.on('init', function (event, slick) {
      var currentSlide = slick.currentSlide;
      if (currentSlide !== 0) {
        $('.hero > .screen-0').removeClass('current');
        $('.hero > .screen-' + currentSlide).addClass('current');
      }
    });

    var landingMapping = {
      link: 0,
      rap: 1,
      instapay: 2,
    };

    var initialSlide = 0;

    if (landingParam in landingMapping) {
      initialSlide = landingMapping[landingParam];
    }

    r.$heroCarousel
      .slick({
        arrows: true,
        slidesToShow: 1,
        dots: true,
        adaptiveHeight: true,
        nextArrow: '<div class="carousel-arrow next"><i class="icon icon-angle-right icon-8x" style="color: #93A0AF;margin-top: -24px;"></i></div>',
        prevArrow: '<div class="carousel-arrow prev"><i class="icon icon-angle-left icon-8x" style="color: #93A0AF;margin-top: -24px;"></i></div>',
        speed: 770,
        cssEase: 'cubic-bezier(.225, .5, .165, 1)',
        appendDots: document.querySelector('#hero-carousel-dots-wrapper'),
        dotsClass: 'slick-imojo-dots',
        initialSlide: initialSlide,
        draggable: false,
        responsive: [{
          breakpoint: 480,
          settings: {
            autoplay: false,
          },
        }],
        autoplaySpeed: 10000,
        pauseOnHover: true,
      });

    r.$heroCarousel.slick('slickPlay');
  }


  function handleSocialLoginClick (signInMethod, signInType) {
    MojoAnalytics.sendEvent({
      eventName: 'Attempted Sign In',
      eventData: {
        signin_method: signInMethod,
        signin_intent: signInType,
      },
    });
  }

  function bindAll () {
    /* init signup section overlay */
    r.$signupTrigger.on('click', handleSignupSection);

    /* init login section overlay */
    r.$loginTrigger.on('click', handleLoginSection);

    /* enable closing overlay by clicking on cross */
    r.$overlayClose.on('click', handleOverlayClose);

    r.$googleLogin.on('click', function () {
      handleSocialLoginClick('google', $(this).data('signinType'));
    });

    r.$facebookLogin.on('click', function () {
      handleSocialLoginClick('facebook', $(this).data('signinType'));
    });

    $(document).on('keydown', handleOverlayCloseViaEsc);

    handleHeroCarousel();
  }

  bindAll();

  // send the page viewed event when the page loads
  MojoAnalytics.sendEvent({
    eventName: 'Viewed Landing Page',
    eventData: {
      page_name: 'education',
    },
  });

  $('#sample-code').click(function () {
    $('#code').removeClass('hide');
    $('#code').animate({ marginTop: '0px' });
    $('#payment').addClass('soft-double--top');
  });

  $('#refer_help').click(function () {
    $('#refer_link').removeClass('hide');
    $('#refer_help').addClass('hide');
  });

  $('#submit-signup').click(function () {
    if ($('#refer_code').val()) {
      $('#id_referrer').val('referral');
      $('#id_utm_campaign').val('refer_code');
      $('#id_utm_medium').val('social');
      $('#id_utm_source').val('referral');
    }
    else {
      $('#id_referrer').removeAttr('value');
      $('#id_utm_campaign').removeAttr('value');
      $('#id_utm_medium').removeAttr('value');
      $('#id_utm_source').removeAttr('value');
    }
  });

  $('#refer_code_error').keyup(function () {
    $('#code_error').addClass('hide');
    $('#refer_code_error').removeClass('parsley-error');
  });
});

define("education", function(){});

